import { BehaviorSubject } from 'rxjs';

export function WrapAsSubject(observable, init = null) {
  const BS = new BehaviorSubject(init);
  observable.subscribe((x) => BS.next(x));
  return BS;
}
